module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Thankyou', {
		init: function() {
			document.domain = location.host;
			
			window.addEventListener(
			'message',
				function (event) {
					if ('http://' + document.domain == event.origin) {
						event.source.postMessage('pong', event.origin);
					}
				},
			false);

			this.callParent('init', arguments);
		}
	});
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/widget/thankyou.js
// module id = 479
// module chunks = 2